export default function AuthInterceptor(localStorageService) {
  return {
    request: function(config) {
      console.log('AuthInterceptor.request: ', config);
      if (!config.headers) {
        config.headers = {};
      }

      if(localStorageService.get('userIdent')){
        config.headers.usertoken =  localStorageService.get('userIdent').usertoken;
      }
      return config;
    }
  };
}

export function AddAuthInterceptor($httpProvider) {
  $httpProvider.interceptors.push(AuthInterceptor);
}




/** WEBPACK FOOTER **
 ** ./src/olr-common/AuthInterceptor.js
 **/